/* ============================================================
   จำการตั้งค่าตารางไว้ใน cookie ของเครื่องนั้น ๆ

   ใช้ cookie ไม่ใช่ localStorage เพราะต้องการให้ผูกกับ "เครื่อง + เบราว์เซอร์"
   และตั้งวันหมดอายุได้ชัดเจน (ค่าเริ่มต้น 1 ปี)

   เก็บเป็น JSON ที่ encodeURIComponent แล้ว จึงใส่ภาษาไทย/เครื่องหมายได้
============================================================ */

const ONE_YEAR_DAYS = 365;

export const setCookie = (name, value, days = ONE_YEAR_DAYS) => {
  try {
    const exp = new Date();
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    const raw = encodeURIComponent(JSON.stringify(value));
    document.cookie = `${name}=${raw};expires=${exp.toUTCString()};path=/;SameSite=Lax`;
  } catch {
    /* cookie ถูกปิด หรือค่ายาวเกินโควตา — ข้ามไป ไม่ต้องขัดจังหวะผู้ใช้ */
  }
};

export const getCookie = (name, fallback = null) => {
  try {
    const hit = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith(`${name}=`));
    if (!hit) return fallback;
    const raw = decodeURIComponent(hit.slice(name.length + 1));
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const removeCookie = (name) => {
  try {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  } catch {
    /* ignore */
  }
};

/* ---------- ตัวช่วยเฉพาะเรื่อง "คอลัมน์ที่ซ่อนไว้" ----------
   เก็บเป็น "รายการคีย์ที่ซ่อน" ไม่ใช่ "รายการที่แสดง"
   เพราะถ้าวันหลังเพิ่มคอลัมน์ใหม่ในโปรแกรม คอลัมน์นั้นจะโผล่มาให้เห็นเอง
   (ถ้าเก็บแบบรายการที่แสดง คอลัมน์ใหม่จะถูกซ่อนโดยไม่ตั้งใจ) */
export const getHiddenColumns = (cookieName) => {
  const v = getCookie(cookieName, []);
  return Array.isArray(v) ? v : [];
};

export const saveHiddenColumns = (cookieName, hiddenKeys) =>
  setCookie(cookieName, Array.isArray(hiddenKeys) ? hiddenKeys : []);
